
import React from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { 
  Select, 
  SelectContent, 
  SelectItem, 
  SelectTrigger, 
  SelectValue
} from "@/components/ui/select";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Search, Filter } from 'lucide-react';

type ProcurementFiltersProps = {
  statusFilter: string;
  typeFilter: string;
  searchQuery: string;
  onFilterChange: (key: string, value: string) => void;
};

const ProcurementFilters = ({ 
  statusFilter, 
  typeFilter, 
  searchQuery, 
  onFilterChange 
}: ProcurementFiltersProps) => {
  return (
    <Card className="mb-6">
      <CardContent className="pt-6">
        <div className="flex flex-col md:flex-row gap-4">
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
            <Input
              placeholder="Sök upphandlingar..."
              className="pl-10"
              value={searchQuery}
              onChange={(e) => onFilterChange('searchQuery', e.target.value)}
            />
          </div>
          
          <div className="flex gap-2">
            <Select 
              defaultValue="all"
              value={statusFilter}
              onValueChange={(value) => onFilterChange('statusFilter', value)}
            >
              <SelectTrigger className="w-[180px]">
                <SelectValue placeholder="Status" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Alla statusar</SelectItem>
                <SelectItem value="Ny">Ny</SelectItem>
                <SelectItem value="Pågående">Pågående</SelectItem>
                <SelectItem value="Analyserad">Analyserad</SelectItem>
              </SelectContent>
            </Select>
            
            <Select 
              defaultValue="all"
              value={typeFilter}
              onValueChange={(value) => onFilterChange('typeFilter', value)}
            >
              <SelectTrigger className="w-[180px]">
                <SelectValue placeholder="Upphandlingstyp" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Alla typer</SelectItem>
                <SelectItem value="construction">Bygg & Anläggning</SelectItem>
                <SelectItem value="it">IT & Digitalisering</SelectItem>
                <SelectItem value="services">Tjänster</SelectItem>
                <SelectItem value="supplies">Varor & Utrustning</SelectItem>
                <SelectItem value="healthcare">Vård & Omsorg</SelectItem>
                <SelectItem value="consulting">Konsulttjänster</SelectItem>
                <SelectItem value="other">Övrigt</SelectItem>
              </SelectContent>
            </Select>
            
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="outline" size="icon">
                  <Filter size={16} />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-56">
                <DropdownMenuItem>Nyast först</DropdownMenuItem>
                <DropdownMenuItem>Äldst först</DropdownMenuItem>
                <DropdownMenuItem>A-Ö</DropdownMenuItem>
                <DropdownMenuItem>Ö-A</DropdownMenuItem>
                <DropdownMenuItem>Deadline (närmast först)</DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ProcurementFilters;
